import { Check } from 'lucide-react';
import { forwardRef, useId, type InputHTMLAttributes, type ReactNode } from 'react';

import styles from './Choice.module.css';
import fieldStyles from './Field.module.css';
import { Icon } from './Icon';

export const Checkbox = forwardRef<
  HTMLInputElement,
  Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
    label: ReactNode;
    description?: ReactNode;
    error?: string;
  }
>(function Checkbox({ label, description, error, id, disabled, ...rest }, ref) {
  const autoId = useId();
  const inputId = id ?? autoId;
  const messageId = `${inputId}-message`;
  return (
    <div className={fieldStyles.field}>
      <label htmlFor={inputId} className={`${styles.choice} ${disabled ? styles.disabled : ''}`}>
        <span className={styles.box}>
          <input
            {...rest}
            ref={ref}
            id={inputId}
            type="checkbox"
            disabled={disabled}
            className={styles.native}
            aria-invalid={error ? true : undefined}
            aria-describedby={error ? messageId : undefined}
          />
          <span className={styles.checkVisual} aria-hidden="true">
            <Icon icon={Check} size={15} />
          </span>
        </span>
        <span className={styles.text}>
          <span className={styles.label}>{label}</span>
          {description && <span className={styles.description}>{description}</span>}
        </span>
      </label>
      {error && (
        <span id={messageId} className={fieldStyles.error}>
          {error}
        </span>
      )}
    </div>
  );
});
